"use client";

import type { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * Keeps the long explanations off the screen until asked for — the old editor
 * carried 171 words of permanently visible prose.
 */
export function InfoHint({ children }: { children: ReactNode }) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="What is this?"
            className="flex h-[17px] w-[17px] items-center justify-center rounded-full border text-[10.5px] font-semibold leading-none text-muted-foreground hover:border-pink-300 hover:text-pink-700"
          >
            i
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-[290px] text-xs leading-relaxed">
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
